import * as productionModule from './useAnimation.prod';
import * as testModule from './useAnimation.jest';
export const useAnimation = process.env.NODE_ENV === 'test'
    ? testModule.useAnimation
    : productionModule.useAnimation;
//# sourceMappingURL=index.js.map